import { render, staticRenderFns } from "./ExtraSalary.vue?vue&type=template&id=ef4f6884&"
import script from "./ExtraSalary.vue?vue&type=script&lang=js&"
export * from "./ExtraSalary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports